import { create } from 'zustand';
import type { DeleteScope, Track } from '@pujolisique/shared';

export interface MenuItem {
  label: string;
  icon?: React.ReactNode;
  onSelect: () => void;
  danger?: boolean;
  disabled?: boolean;
}

/** Demande de suppression définitive (fenêtre de confirmation) */
export interface DeleteRequest {
  scope: DeleteScope;
  /** Ce qu'on supprime, pour le titre de la fenêtre (« l’album Nocturnes ») */
  label: string;
  /** Après la suppression (quitter une page devenue vide…) */
  onDone?: () => void;
}

interface UiState {
  menu: { x: number; y: number; items: MenuItem[]; title?: string } | null;
  playlistPicker: Track[] | null;
  openMenu(e: { clientX: number; clientY: number } | DOMRect, items: MenuItem[], title?: string): void;
  closeMenu(): void;
  pickPlaylist(tracks: Track[] | null): void;
  deleteRequest: DeleteRequest | null;
  askDelete(req: DeleteRequest | null): void;
}

export const useUi = create<UiState>((set) => ({
  menu: null,
  playlistPicker: null,
  openMenu(e, items, title) {
    const x = 'clientX' in e ? e.clientX : e.right;
    const y = 'clientY' in e ? e.clientY : e.bottom;
    set({ menu: { x, y, items, title } });
  },
  closeMenu() {
    set({ menu: null });
  },
  pickPlaylist(tracks) {
    set({ playlistPicker: tracks, menu: null });
  },
  deleteRequest: null,
  askDelete(req) {
    set({ deleteRequest: req, menu: null });
  },
}));

/** Mode intégré (iframe intranet) : ?embed=1 ou détection d'iframe */
export const isEmbedded = (() => {
  try {
    return new URLSearchParams(location.search).has('embed') || window.self !== window.top;
  } catch {
    return true;
  }
})();
